module.exports = "<a routerLink=\"\">\n    <img id=\"signature\" src={{icon}} alt=\"Our Signature\">\n</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/structural_components/main-icon/main-icon.component.html
// module id = 417
// module chunks = 1